import { get } from '../lib/api';
import { makeGrowerPath } from '../lib/api/utils';

export function getFieldRevisions(aaid, params = {}) {
  const options = { ...(params ? { params } : {}) };
  return get(makeGrowerPath(`/fields/${aaid}/revisions`), options);
}
